import { Component, Input, OnInit } from "@angular/core";
import { FormArray, FormBuilder, Validators, FormGroup } from "@angular/forms";
import { has } from "lodash";
import { Utilities } from "../../providers/utilities";

@Component({
  selector: "app-amount-discount",
  templateUrl: "amount-discount.html",
})
export class AmountDiscountComponent implements OnInit {

  @Input() public globalForm: FormGroup;
  @Input() public arrayControlName: string;
  @Input() public currentObject: any;

  constructor(
    private formBuilder: FormBuilder,
    private ut: Utilities,
  ) { }

  public ngOnInit() {
    if (this.currentObject) {
      if (has(this.currentObject, this.arrayControlName)) {
        (this.currentObject[this.arrayControlName] as any[]).map((discount) => this.addDiscount(discount));
      }
    }
  }

  public addDiscount(discount) {
    const control = this.globalForm.get(this.arrayControlName) as FormArray;
    control.push(this.createDiscount(discount));
  }

  public removeDiscount({ group, index }: { group: FormGroup, index: number }) {
    const control = this.globalForm.get(this.arrayControlName) as FormArray;
    control.removeAt(index);
  }

  get discounts() {
    return (this.globalForm.get(this.arrayControlName) as FormArray).controls;
  }

  private createDiscount(discount = null) {
    return this.formBuilder.group({
      id: this.formBuilder.control(discount ? discount.id : this.ut.generateRamdomKey(), Validators.required),
      quantityMin: this.formBuilder.control(discount ? discount.quantityMin : 0, Validators.required),
      quantityMax: this.formBuilder.control(discount ? discount.quantityMax : 0, Validators.required),
      type: this.formBuilder.control(discount ? discount.type : "price", Validators.required),
      expiresDate: this.formBuilder.control(discount ? discount.expiresDate : ""),
      value: this.formBuilder.control(discount ? discount.value : 0, Validators.required),
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/amount-discount/amount-discount.ts